import React from 'react';
import PropTypes from 'prop-types';
import StickyFooterLayout from '../common/StickyFooterLayout';
import StudentListTable from './StudentListTable';
import TableInformation from '../SF/table/TableInformation';

function StudentList(props) {

  const getStickyFooter = () =>
      <TableInformation itemName={props.itemName}
                        itemsPerPage={props.studentsPerPage}
                        start={props.start}
                        totalItems={props.totalStudents}
                        totalSelected={props.selectedStudents.length} />;

  return <StickyFooterLayout content={(<StudentListTable {...props} />)} 
                             footer={getStickyFooter()} />
  
}

StudentList.defaultProps = {
  itemName: 'Students'
};

StudentList.propTypes = {
  itemName: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
  selectedStudents: PropTypes.arrayOf(PropTypes.number).isRequired,
  studentsPerPage: PropTypes.number.isRequired,
  totalStudents: PropTypes.number.isRequired
};

export default StudentList;
